import { render } from "./IconChevronMenu.vue?vue&type=template&id=049d6121"
import script from "./IconChevronMenu.vue?vue&type=script&lang=js"
export * from "./IconChevronMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__